import { RouteComponentProps } from "@reach/router";
import { Form, DropdownButton, Dropdown, Tooltip } from "react-bootstrap";
import { OverlayTrigger } from "../../Components";
import { filterSegmentationIds, generateFormattedDate } from "../MetaBuyingUtils";
import * as R from "ramda";
import {
  CLIENT,
  AGENCY,
  SEGMENTATION_ID,
  SEGMENT_SELECTION,
  CURRENT_DATE,
  AD_SET,
} from "../MetaBuyingConstants";

const INHERITED = "INHERITED";

interface MetaBuyingNameFieldsProps {
  client: string;
  agency: string;
  segmentationDimensionId: string;
  dimensions: Record<string, any>;
  nameFields: Record<string, any>;
  namingConvention: number[];
  setNameField: (id: string, value: string, updateType: "state" | "context" | "all") => void;
  allNameFields: Record<string, any>;
  thisLevel: string;
  disabled?: boolean;
}

export const MetaBuyingNameFields = ({
  client,
  agency,
  segmentationDimensionId,
  dimensions,
  nameFields,
  namingConvention,
  setNameField,
  allNameFields,
  thisLevel,
  disabled = false,
}: MetaBuyingNameFieldsProps & RouteComponentProps): JSX.Element => (
  <>
    {namingConvention.map(dimensionId => {
      const dimension = dimensions[dimensionId];

      const { inheritedFrom } = allNameFields[dimensionId];

      const dimensionType =
        R.isNil(inheritedFrom) || thisLevel === inheritedFrom ? dimension.type : INHERITED;

      let dropdownOptions =
        dimensionType === SEGMENTATION_ID
          ? filterSegmentationIds(
              R.map(({ value }) => value, allNameFields),
              dimensions,
              segmentationDimensionId
            )
          : dimension.options;
      let field;
      let value;

      switch (dimensionType) {
        case AGENCY:
        case CLIENT:
        case CURRENT_DATE:
          value =
            dimensionType === CLIENT
              ? client
              : dimensionType === AGENCY
              ? agency
              : generateFormattedDate(dimension.date_format);
          field = <Form.Control value={value} className="disabled" disabled />;
          break;
        case INHERITED:
          field = (
            <OverlayTrigger
              placement="right center"
              overlay={
                <Tooltip id={`id:${nameFields[dimensionId]}`}>
                  Inherited from {inheritedFrom === AD_SET ? "adset" : inheritedFrom}
                </Tooltip>
              }
            >
              <Form.Control value={nameFields[dimensionId]} className="disabled" disabled />
            </OverlayTrigger>
          );
          break;
        case SEGMENTATION_ID:
        case SEGMENT_SELECTION:
          field = (
            <DropdownButton
              title={nameFields[dimensionId]}
              onSelect={value => setNameField(dimensionId.toString(), value || "", "all")}
              disabled={dropdownOptions.length === 0 || disabled}
            >
              {dropdownOptions.map(option => (
                <Dropdown.Item key={option} eventKey={option}>
                  {option}
                </Dropdown.Item>
              ))}
            </DropdownButton>
          );
          break;
        default:
          field = (
            <Form.Control
              onBlur={e => {
                if (allNameFields[dimensionId].value !== e.target.value) {
                  setNameField(dimensionId.toString(), e.target.value, "context");
                }
              }}
              value={nameFields[dimensionId]}
              onChange={e => setNameField(dimensionId.toString(), e.target.value, "state")}
              className={disabled ? "disabled" : ""}
              disabled={disabled}
            />
          );
          break;
      }
      return (
        <Form.Group key={dimensionId}>
          <Form.Label>{dimension.name}</Form.Label>
          {field}
        </Form.Group>
      );
    })}
  </>
);

export default MetaBuyingNameFields;
